import React, { useState } from 'react'
import styled from 'styled-components'

import { useCartContext } from '../../../lib/cart'
import MiniCartModal from './MiniCartModal'
import OpenMiniCart from './OpenMiniCart'

export interface MiniCartContainerProps {
  className?: string
}

const MiniCartContainer: React.FC<MiniCartContainerProps> = ({ className }) => {
  const { cart } = useCartContext()
  const [openMiniCartModal, setOpenMiniCartModal] = useState(false)

  if (!cart) {
    return null
  }

  return (
    <div className={className}>
      <OpenMiniCart cart={cart} setOpenMiniCartModal={setOpenMiniCartModal} />
      <MiniCartModal
        cart={cart}
        disableButtons={false}
        handleClose={() => setOpenMiniCartModal(false)}
        open={openMiniCartModal}
      />
    </div>
  )
}

const StyledMiniCartContainer = styled(MiniCartContainer)({
  marginLeft: 'auto',
  position: 'relative',
  '@media(min-width: 600px)': {
    marginLeft: 'unset',
    // set position to absolute to allow centered logo
    position: 'absolute',
    right: '8px',
  },
  '@media(min-width: 960px)': {
    display: 'none',
  },
})

export default StyledMiniCartContainer
